import Action, { ActionMoshaveran, ActionMoshaveranFetchError, ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import MoshaveranState from '../State/MoshaveranState'

const actionMoshaveranFetchError = (oldState: MoshaveranState, action: Action): MoshaveranState => {
    return { ...oldState, error: (action as ActionMoshaveranFetchError).message, loading: false }
}

const actionMoshaveranFetchLoading = (oldState: MoshaveranState, _action: Action): MoshaveranState => {
    return { ...oldState, loading: true, error: undefined }
}

const actionMosgaveran = (oldState: MoshaveranState, action: Action): MoshaveranState => {
    return { ...oldState, loading: false, error: undefined, data: (action as ActionMoshaveran).data }
}



type Process = (oldState: MoshaveranState, action: Action) => MoshaveranState

export const MoshaveranReducer: Reducer<MoshaveranState, Action> = (state: MoshaveranState = {
    data: [], loading: false, error: undefined
}, action: Action): MoshaveranState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.MOSHAVERAN_LOAGING, actionMoshaveranFetchLoading)
    actionMap.set(ActionType.MOSHAVERAN_DATA, actionMosgaveran)
    actionMap.set(ActionType.MOSHAVERAN_ERROR, actionMoshaveranFetchError)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


